import { Context, createContext, ReactNode, useState } from "react";

interface TabNavigationContextType {
  sectionRefs: Record<string, { title: string; ref: HTMLElement | null }>;
  addSectionRef: (id: string, title: string, ref: HTMLElement | null) => void;
  removeSectionRef: (id: string) => void;
}

export const TabNavigationContext: Context<
  TabNavigationContextType | undefined
> = createContext<TabNavigationContextType | undefined>(undefined);
TabNavigationContext.displayName = "TabNavigationContext";

export function TabNavigationProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const [sectionRefs, setSectionRefs] = useState<
    Record<string, { title: string; ref: HTMLElement | null }>
  >({});

  const addSectionRef = (
    id: string,
    title: string,
    ref: HTMLElement | null,
  ) => {
    setSectionRefs((prev) => ({ ...prev, [id]: { title, ref } }));
  };

  const removeSectionRef = (id: string) => {
    setSectionRefs((prev) => {
      const { [id]: _, ...rest } = prev;
      return rest;
    });
  };

  return (
    <TabNavigationContext.Provider
      value={{ sectionRefs, addSectionRef, removeSectionRef }}
    >
      {children}
    </TabNavigationContext.Provider>
  );
}
